module.exports = __webpack_public_path__ + "img/806f62c20f1fce2d52fb5fa1ce500499.52ddb4aa.png";